export default function customModal(state = {}, action)
{
    // console.log("action",action)
    // console.log("state",state)
    switch (action.type){
        case 'SHOW_MODAL': 
            // return Object.assign({}, state, {
                
            //     objectValues: action.customModal
            // })
            return {
                ...state,
                ...action.customModal
            }
        case 'CLOSE_MODAL': 
            // return Object.assign({}, state, {
            //     objectValues: action.customModal
            // })

            return {
                ...state,
                ...action.customModal
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/customModal.js